<section class="container">
<div class="optimize mt-3 container" [id]="data?.id">
  <h3 class="section-title text-center mb-3" *ngIf="data?.title">
    {{ data.title.split(" ")[0] }}
    <span>{{ data.title.split(" ").slice(1).join(" ") }}</span>
  </h3>

  <div
    class="row service-block justify-content-center align-items-center mb-3"
    *ngFor="let item of data.services; let i = index"
  >
    <div
      class="col-12 col-md-7 col-lg-8 px-4 order-2"
      [class.order-md-1]="i % 2 === 0"
      [class.order-md-2]="i % 2 !== 0"
    >
      <h3 class="service-title ">
        {{ item.titleTr }}
      </h3>
      <div class="description mb-4" [innerHTML]="item.summary"></div>

      <button
        class="details-btn"
        [routerLink]="getDetailsUrl(item)"
        *ngIf="data.isDetails"
      >
        {{ "details" | translate }}
      </button>
    </div>

    <div
      class="col-12 col-md-5 col-lg-4 text-center order-1"
      [class.order-md-2]="i % 2 === 0"
      [class.order-md-1]="i % 2 !== 0"
    >
      <div class="image-wrapper mb-4 mb-md-0">
        <img
          class="img-fluid rounded shadow-sm"
          [src]="item.imageIconPath"
          [alt]="item.imageAlt"
        />
      </div>
    </div>
  </div>
</div>
</section>